import { useLingui } from '@lingui/react/macro'
import { Text } from 'designSystem/components/Text'
import { usePipelineConfig } from 'features/knowledgeDocumentViewer/contexts/PipelineConfigContext'
import { PermissionsGate } from 'features/permissions'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

import {
  PreviewModeSwitchButton,
  PreviewModeSwitchThumb,
  PreviewModeSwitchTrack,
} from './documentTabsStyles'

export function DocumentPreviewModeSwitch() {
  const { t } = useLingui()
  const { isPreviewMode, setIsPreviewMode, hasPreviewConfig } =
    usePipelineConfig()

  const handlePreviewModeToggle = (): void => {
    setIsPreviewMode((currentValue) => !currentValue)
  }

  return (
    <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
      {hasPreviewConfig && (
        <PreviewModeSwitchButton
          type='button'
          role='switch'
          aria-checked={isPreviewMode}
          aria-label={isPreviewMode ? t`Preview mode on` : t`Preview mode off`}
          title={t`Toggle Preview Mode`}
          $checked={isPreviewMode}
          onClick={handlePreviewModeToggle}>
          <PreviewModeSwitchTrack $checked={isPreviewMode}>
            <PreviewModeSwitchThumb $checked={isPreviewMode} />
          </PreviewModeSwitchTrack>
          <span>{t`Preview`}</span>
          <Text color='muted'>{isPreviewMode ? t`On` : t`Off`}</Text>
        </PreviewModeSwitchButton>
      )}
    </PermissionsGate>
  )
}
